import listPage from "./listPage";
import detailPage from "./detailPage";
import createPage from "./createPage";
import editPage from "./editPage";

const exportObjs = {
  List: listPage,
  Detail: detailPage,
  Create: createPage,
  Edit: editPage,
};

export default exportObjs;
